module.exports = __webpack_public_path__ + "img/laodelphax-striatellus.fa8fa01e.jpg";